import React from "react";
import {LogoWidget} from "./logo_widget";
import styled from "styled-components";
import {WidthStyle} from "../style/width_style";
import {NavWidget} from "./nav_widget";

export const HeaderWidget: React.FC = () => {
    return (
        <HeaderStyle>
            <div>
                <LogoWidget/>
                <NavWidget/>
            </div>

        </HeaderStyle>
    );
}


const HeaderStyle = styled.div`
 
  height: 80px;
 
  background-color: #140A5C;

  > div {
    ${WidthStyle.MaxWidth};
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }
`
